import Modal from "antd/es/modal/Modal";
import React from "react";
import { FailedLogo } from "../../../../../asset";
import PrimaryButton from "../../../../../component/button/PrimaryButton";

const PopUpMaxOrderSelected = ({ modalPopUpMaxOrderSelected, close }) => {
  return (
    <Modal
      title=""
      open={modalPopUpMaxOrderSelected}
      onCancel={close}
      footer={null}
      width="615px"
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <img src={FailedLogo} alt="logo-failed" />
        <span className="font-bold text-[28px] text-[#1D1D1D]">
          Maximum Order Limit Reached
        </span>
        <div className="font-normal text-lg text-[#666666] flex flex-col text-center align-middle">
          <span> You have reached the maximum limit for chosen orders. </span>
          <span>
            To add more, please remove one or more of your current selections
          </span>
        </div>

        <button
          className="bg-red-100 w-full rounded-md px-2 py-4 text-[#FFFFFF]"
          onClick={close}
        >
          {" "}
          OK{" "}
        </button>
      </div>
    </Modal>
  );
};

export default PopUpMaxOrderSelected;
